export enum JobType {
    NextBestAction = 'nba',
    MarketingMixModel = 'MMM',
    MultiTouchAttribution = 'mta',
    GeoLift = 'GEO_LIFT',
    CustomTargeting = 'ctar',
    BidOptimizer = 'BidOptimizer',
    RctExperiment = 'RCT_EXPERIMENT',
    CausalLoop = 'CausalLoop',
    CausalLoopRct = 'CausalLoopRct',
}
